import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { AlertTriangle, FileCode } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtData = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '-');

/** Widget Dashboard: fatture generate automaticamente dai contratti NON ancora inviate allo SdI. */
export const WidgetFattureContrattoSdi = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/dashboard/fatture-contratto-sdi`);
      setData(res.data);
    } catch (e) {
      console.error('Errore fatture contratto SdI:', e);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  if (!data || data.count === 0) return null;

  return (
    <Card className="border-red-300 dark:border-red-900" data-testid="widget-fatture-contratto-sdi">
      <CardHeader className="pb-3">
        <CardTitle
          className="text-sm font-mono uppercase flex items-center gap-2 flex-wrap cursor-pointer hover:text-red-600 transition-colors"
          onClick={() => navigate('/documenti')}
          data-testid="fatture-contratto-titolo"
        >
          <AlertTriangle className="h-4 w-4 text-red-600 animate-pulse" />
          Fatture da contratto — da inviare allo SdI
          <Badge className="text-[10px] bg-red-600 text-white" data-testid="fatture-contratto-count">
            {data.count}
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-1.5">
        <p className="text-[11px] text-muted-foreground -mt-1 mb-2">
          Generate automaticamente al rinnovo del contratto di assistenza. Scarica l'XML, caricalo su Aruba,
          poi clicca "Segna inviata a SdI": l'email al cliente partirà da sola.
        </p>
        {data.fatture.slice(0, 8).map((f) => (
          <div
            key={f.id}
            className="flex items-center gap-2 rounded-md border border-red-200 dark:border-red-900 bg-red-50/50 dark:bg-red-950/10 px-2.5 py-1.5 cursor-pointer hover:bg-red-50 dark:hover:bg-red-950/30 transition-colors"
            onClick={() => navigate('/documenti')}
            data-testid={`fattura-contratto-riga-${f.id}`}
          >
            <FileCode className="h-3.5 w-3.5 text-red-600 shrink-0" />
            <span className="font-mono text-xs font-bold shrink-0">{f.anno}/{String(f.numero).padStart(3, '0')}</span>
            <span className="text-xs truncate flex-1">{f.cliente || '-'}</span>
            <span className="font-mono text-xs font-medium shrink-0">€ {f.totale.toFixed(2)}</span>
            <span className="text-[10px] text-muted-foreground shrink-0">{fmtData(f.data_documento)}</span>
          </div>
        ))}
        {data.count > 8 && (
          <p className="text-[11px] text-muted-foreground text-right cursor-pointer hover:underline" onClick={() => navigate('/documenti')}>
            + altre {data.count - 8} fatture…
          </p>
        )}
      </CardContent>
    </Card>
  );
};
